import React from "react";
import type { AdminQuest } from "common/types/questManagement.type";

interface DeleteQuestModalProps {
  quest: AdminQuest | null;
  isDeleting: boolean;
  errorMessage: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteQuestModal = ({
  quest,
  isDeleting,
  errorMessage,
  onCancel,
  onConfirm,
}: DeleteQuestModalProps) => {
  if (!quest) return null;

  return (
    <div className="absolute inset-0 z-40 flex items-center justify-center bg-white/70 px-[24px]">
      <div className="w-full max-w-[460px] rounded-[6px] border border-[#1b4b86] bg-white p-[28px] shadow-[0_8px_24px_rgba(0,0,0,0.18)]">
        <h2 className="border-l-[4px] border-[#1b4b86] pl-[12px] text-[20px] font-bold leading-[1.6] text-[#1b4b86]">
          クエスト削除
        </h2>

        <p className="mt-[24px] text-[15px] leading-[1.8] text-black">
          「{quest.title}」を削除しますか？
        </p>
        <p className="mt-[8px] text-[13px] leading-[1.6] text-[#de3c3f]">
          削除するとユーザーの進捗データも消失します。
        </p>

        {errorMessage ? (
          <p className="mt-[16px] whitespace-pre-line text-[13px] leading-[1.6] text-[#de3c3f]">
            {errorMessage}
          </p>
        ) : null}

        <div className="mt-[28px] grid grid-cols-2 gap-[15px]">
          <button
            className="flex h-[46px] items-center justify-center rounded-[6px] bg-[#eef5fa] text-[16px] font-bold leading-[1.6] text-[#1b4b86] disabled:opacity-50"
            disabled={isDeleting}
            onClick={onCancel}
            type="button"
          >
            キャンセル
          </button>
          <button
            className="flex h-[46px] items-center justify-center rounded-[6px] bg-[#de3c3f] text-[16px] font-bold leading-[1.6] text-white disabled:opacity-50"
            disabled={isDeleting}
            onClick={onConfirm}
            type="button"
          >
            {isDeleting ? "削除中..." : "削除する"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteQuestModal;
